import React from 'react'
import { Box, Td, Tr, Tbody, TableContainer, Table, Thead, Th, Text } from '@chakra-ui/react'
import moment from 'moment'

export default function EMITable({ data }) {
    return (
        <Box mt={1} className='custom_table_wrapper report-table'>
            <TableContainer>
                <Table variant="striped">
                    <Thead>
                        <Tr>
                            <Th>Date</Th>
                            <Th>Transaction</Th>
                            <Th>Credit</Th>
                            <Th>Debit</Th>
                            <Th>Balance</Th>
                            <Th>Transaction Mode</Th>
                            <Th>Transaction Type</Th>
                            <Th>Party 1</Th>
                            <Th>Party 2</Th>
                            <Th>Bank</Th>
                            <Th>Category</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data?.map((item, index) => {
                            return (
                                <Tr key={index}>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Date ? moment(item.Date).format('DD/MM/YYYY'): ''}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Transaction}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Credit}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Debit}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">₹{item.Balance}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item['Transaction Mode']}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item['Transaction Type']}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item['Party 1']}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item['Party 2']}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Bank}</Text>
                                    </Td>
                                    <Td>
                                        <Text className="font-poppins table_text">{item.Category}</Text>
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    )
}
